import {
    nextId,
    allWorks,
    idByIdx
} from '../selectors/worksSelectors';
import Work, {Id} from 'types/Work';

// Note: Navigation now handled by components using useNavigate hook
export function navigateTo(url){
	// This function is deprecated - use useNavigate hook in components instead
	return {type: 'NAVIGATE_TO', url};
}

export const LOCATION_CHANGE = "@@router/LOCATION_CHANGE";

export type GO_TO = 'GO_TO';
export const GO_TO: GO_TO = 'GO_TO';
export type GoToAction = {
    type: GO_TO, id: Id
}
export function goTo(id: Id): GoToAction{
    return {type: GO_TO, id};
}

export type NEXT = 'NEXT';
export const NEXT: NEXT = 'NEXT';
export const next = () =>
    async (dispatch, getState): Promise<Id> => {
        let next = nextId(getState());
        if (next) {
            dispatch(goTo(next));
            // Navigation should be handled in component with useNavigate
            return next;
        }
    }

export type RANDOM_WORK = 'RANDOM_WORK';
export const RANDOM_WORK: RANDOM_WORK = 'RANDOM_WORK';
export const randomWork = () =>
    async (dispatch, getState): Promise<Id> => {
        let state = getState();
        let byIdx = idByIdx(state);
        let numWorks = allWorks(state).length;
        let randomIdx = Math.floor(Math.random() * numWorks);
        let next = byIdx[randomIdx];
        dispatch(goTo(next));
        // Navigation should be handled in component with useNavigate
        return next;
    }

export const PREVIOUS = 'PREVIOUS';
export const previous = (id?: Id, works?: Work[]) =>
    async (dispatch, getState): Promise<Id> => {
        let state = getState();
        let { lookup, all } = state.works;
        if (!id) {
            id = state.works.id;
        }
        if (id) {
            let idx = lookup[id];
            if (idx > 0) {
                let prevId = works
                    ? works[idx - 1].id
                    : all[idx - 1].id;
                // Navigation should be handled in component with useNavigate
                return prevId;
            }
        }
    }

export const VIDEO_ENDED = 'VIDEO_ENDED';
export const videoEnded = () =>
    async (dispatch, getState): Promise<void> => {
        let state = getState();
        let work = state.works.work;
        let auto = state.ui.auto;
        if (auto && work.type === 'video') {
            dispatch(next());
        }
        return;
    }